import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { find, has, sortBy } from 'lodash'
import { getLogRevisionChangelog } from '../../../../../common/utils'
import { TimelineRow } from '../../../../../components/generic'
import LogRevisionItem from './LogRevisionItem'
import { colors } from '@lmc/common/constants'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'

export class LogRevisions extends PureComponent {
  getIcon = () => {
    const { category, item } = this.props
    const chosenItem = item && item.icon ? item : category
    return chosenItem && chosenItem.icon ? chosenItem.icon : ''
  }

  getIconColor = () => {
    const { category, item } = this.props
    const chosenItem = item && item.color ? item : category
    return chosenItem && chosenItem.color ? chosenItem.color : colors.darkblue
  }

  /**
   * The last item in the sorted list will contain the data of the original
   * log, so there are no changes to display. Otherwise compare current the
   * revision with its predecessor, which will be next along in the list.
   */
  getRevisionChangelog = (revisions, index) => {
    if (index === revisions.length - 1) return []
    return getLogRevisionChangelog(revisions[index], revisions[index + 1])
  }

  sortRevisions = (revisions) => [
    this.props.log,
    ...sortBy(revisions, 'revokedAt').reverse(),
  ]

  populateRevisionCarers = (revisions) => {
    const items = this.sortRevisions(revisions)
    return items.map((item, index) => {
      const carerKey = has(item, 'revokedBy') ? 'revokedBy' : 'editedBy'
      const carer = find(this.props.carers, { id: item[carerKey] })
      return { ...item, [carerKey]: carer }
    })
  }

  renderEmpty = () => (
    <EmptyState
      title="Shoot... No data to show you"
      description={NO_REVISIONS}
      icon={<NoDataIcon />}
    />
  )

  render() {
    const { carers, category, log, item, testId } = this.props

    if (!carers || (!category && !item)) return null
    if (!log.logRevisions.length) return this.renderEmpty()

    const logWithCarer = {
      ...log,
      loggedBy: find(carers, { id: log?.loggedBy }),
    }
    const revisions = this.populateRevisionCarers(log.logRevisions)

    return (
      <div data-testid={testId || 'log-revisions'}>
        {revisions.map((revision, i) => {
          const isOriginalLog = i === revisions.length - 1
          return (
            <TimelineRow
              icon={{
                url: this.getIcon(),
                color: this.getIconColor(),
              }}
              key={revision.id}
              showConnector={!isOriginalLog}
              data-testid={testId ? `${testId}-revision-${i}` : `log-revisions-revision-${i}`}
            >
              <LogRevisionItem
                changelog={this.getRevisionChangelog(revisions, i)}
                isCurrent={i === 0}
                log={logWithCarer}
                revision={revision}
                showEdited={!isOriginalLog}
                testId={testId ? `${testId}-revision-${i}` : `log-revisions-revision-${i}`}
              />
            </TimelineRow>
          )
        })}
      </div>
    )
  }
}

const NO_REVISIONS = 'No revisions have been made to this log'

const styles = {
  emptyMessage: {
    fontSize: 16,
  },
}

LogRevisions.propTypes = {
  carers: PropTypes.array,
  category: PropTypes.object,
  item: PropTypes.object,
  log: PropTypes.object.isRequired,
  testId: PropTypes.string,
}

const mapStateToProps = (state, { log }) => ({
  carers: state.data.carers,
  category: find(state.data['log-categories'], { id: log.category }),
  item: find(state.data['log-category-items'], { id: log.item }),
})

export default connect(mapStateToProps)(LogRevisions)
